export default __webpack_public_path__ + "static/media/black360.ce875e5f.gif";